import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "b-worker__inner"
}
const _hoisted_2 = { class: "h-flex h-flex-dir-column" }
const _hoisted_3 = { class: "b-worker__name" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwIcon = _resolveComponent("FwIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["b-worker__info", _ctx.wrapperClass])
  }, [
    _createElementVNode("div", {
      class: "b-worker__avatar",
      style: _normalizeStyle(_ctx.workerStyle)
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([{ "b-worker__avatar__color--gradient": !_ctx.worker.id }, "b-worker__avatar__color"])
      }, [
        (!_ctx.worker.avatar_url)
          ? (_openBlock(), _createBlock(_component_FwIcon, {
              key: 0,
              class: "b-worker__avatar__icon",
              icon: "no-avatar",
              size: `${_ctx.avatarSize / 2}`,
              color: "#fff"
            }, null, 8, ["size"]))
          : _createCommentVNode("", true)
      ], 2)
    ], 4),
    (!_ctx.hideInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: _normalizeClass(["b-worker__position", [
                     _ctx.nameClass,
                     { "b-worker__position--ghost": !_ctx.worker.full_name }
                 ]])
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$tc(_ctx.workerName)), 1)
            ], 2),
            _createElementVNode("div", _hoisted_3, [
              (_ctx.user.kind && !_ctx.worker.role_name)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.kindText), 1))
                : (_ctx.advisorLabel)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t(_ctx.advisorLabel)), 1))
                  : (_ctx.worker.role_name)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.worker.role_name), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$tc('CHOOSE_MANAGE.COMMON.NO.WORKER.PLURAL')), 1))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}